import { Eye } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import { useFormat } from '@nucleus-commerce/i18n/react';
import { Alert, AlertDescription, AlertTitle } from '@nucleus-commerce/ui/components/alert';

import { session } from '@/shared/session/session';

/**
 * Shown while a platform operator looks at the organisation through a support session. The
 * session can only read: its permissions are every `*.read`, so write affordances gated by
 * permission disappear on their own and the backend refuses the rest (SUPPORT_SESSION_READ_ONLY).
 */
export function SupportSessionBanner() {
  const { t } = useTranslation('auth');
  const format = useFormat();
  const { me } = session.useSession();
  const support = me?.supportSession;
  if (!support) return null;
  return (
    <Alert role="status" className="mb-4" data-testid="support-session-banner">
      <Eye aria-hidden />
      <AlertTitle>
        {t('supportSession.title', {
          name: support.platformUser.name,
          email: support.platformUser.email,
        })}
      </AlertTitle>
      <AlertDescription>
        <span className="block">{t('supportSession.reason', { reason: support.reason })}</span>
        <span className="block" title={format.utc(support.expiresAt)}>
          {t('supportSession.expires', { when: format.dateTime(support.expiresAt) })}
        </span>
      </AlertDescription>
    </Alert>
  );
}
